<template>
    <div v-if="selectTypeGroupFirst" class="box">
        <Tabs @on-click="switchTab" :value="filter.selectType.toString()" :animated="false">
            <TabPane v-if="hasPermission('selectShareGroupList')&&userGroupList.length>0" name="3" :label="$t('Button.userGroup')">
                <slot name="userGroupTab"></slot>
            </TabPane>
            <TabPane name="1" :label="$t('Button.labelMine')">
                <slot name="mySwitchTab"></slot>
            </TabPane>
             <TabPane v-if="(isShow||isSuperAdmin||isDepartmentAdmin)&&(hasDepartmentMenus==1)&&(departmentId!=0)" name="2" :label="$t('Button.department')">
                <slot name="departmentTab"></slot>
            </TabPane>
        </Tabs>
    </div>
    <div v-else class="box">
        <Tabs @on-click="switchTab" :value="filter.selectType.toString()" :animated="false">
            <TabPane name="1" :label="$t('Button.labelMine')">
                <slot name="mySwitchTab"></slot>
            </TabPane>
            <TabPane v-if="hasPermission('selectShareGroupList')&&userGroupList.length>0" name="3" :label="$t('Button.userGroup')">
                <slot name="userGroupTab"></slot>
            </TabPane>
            <TabPane v-if="(isShow||isSuperAdmin||isDepartmentAdmin)&&(hasDepartmentMenus==1)&&(departmentId!=0)" name="2" :label="$t('Button.department')">
                <slot name="departmentTab"></slot>
            </TabPane>
        </Tabs>
    </div>
</template>           

<script>
import { mapState } from "vuex";
import apimodel from "@/model/ApiModel";

let { Const } = apimodel;

/*
    额外需求 NEED：
    NEED-1 输入完整名字后，自动选择
    NEED-2 手动清空输入后，需要显示可选列表
    NEED-3 外部可以获取label

*/
export default {
    props:["filterPath","filterValue"],
    computed: {
        isShow() {
            return this.model ? this.model.isShow : false;
        },
        model: {
            get() {
                if (this.filterPath === "views/liveRoom.all.filter") {
                    // this.isShow = this.hasPermission('selectliveRoomData')||this.hasPermission('updateliveRoomData')
                    return {
                        isShow: this.hasPermission('selectliveRoomData'),
                        filter: this.$store.state.views.liveRoom.all.filter,
                    };
                } else if (this.filterPath === "views/relatedReport.all.filter") {
                    // this.isShow =this.hasPermission('selectCorrelativeReport')||this.hasPermission('updateCorrelativeReport')
                    return {
                        isShow: this.hasPermission('selectCorrelativeReport'),
                        filter: this.$store.state.views.relatedReport.all.filter,
                    };
                } else if (this.filterPath === "views/liveRecord.all.filter"){
                    return {
                        isShow: this.hasPermission('selectliveTaskHisData'),
                        filter: this.$store.state.views.liveRecord.all.filter,                    
                    };
                } else if (this.filterPath === "views/category.all.filter") {
                    // this.isShow =this.hasPermission('selecteMaterialInfoData')||this.hasPermission('updateMaterialInfoData')
                    return {
                        isShow: this.hasPermission('selecteMaterialInfoData'),
                        filter: this.$store.state.views.category.all.filter,
                    };
                } else if (this.filterPath === "views/watermark.all.filter") {
                    // this.isShow =this.hasPermission('selectWatermarkChildData')||this.hasPermission('updateWatermarkChildData')
                    return {
                        isShow: this.hasPermission('selectWatermarkChildData'),
                        filter: this.$store.state.views.watermark.all.filter,
                    }
                } else if (this.filterPath === "views/cloudEditor.all.filter") {
                    // this.isShow =this.hasPermission('selectCloudEditorData')||this.hasPermission('updateCloudEditorData')
                    return {
                        isShow: this.hasPermission('selectCloudEditorData'),
                        filter: this.$store.state.views.cloudEditor.all.filter,
                    }
                } else if (this.filterPath === "views/materialTemplate.all.filter"){
                    // this.isShow =this.hasPermission('selectEffectGroupTemplateData')||this.hasPermission('updateEffectGroupTemplateData')
                    return {
                        isShow: this.hasPermission('selectEffectGroupTemplateData'),
                        filter: this.$store.state.views.materialTemplate.all.filter,
                    }
                } else if (this.filterPath === "views/realEditor.all.filter") {
                    // this.isShow =this.hasPermission('selectRealEditorData')||this.hasPermission('updateRealEditorData')
                    return {
                        isShow: this.hasPermission('selectRealEditorData'),
                        filter: this.$store.state.views.realEditor.all.filter,
                    }
                } else if (this.filterPath === "views/director.all.filter") {
                    return {
                        isShow: this.hasPermission('selectDirectorData'),
                        // this.isShow =this.hasPermission('selectDirectorData')||this.hasPermission('updateDirectorData')
                        filter: this.$store.state.views.director.all.filter,
                    }
                } else if (this.filterPath === "views/liveCategory.all.filter") {
                    return {
                        isShow: this.hasPermission("selectLiveRoomCategoryData"),
                        filter: this.$store.state.views.liveCategory.all.filter,
                    }
                }
                throw new Error("非法的 filterPath");
            }, 
        },
        filter: {
            get() {
                return this.model ? this.model.filter : {};
            },                          
            set(v) {
                this.$store.commit(this.filterPath, v);
            }
        },
        ...mapState({
            userGroupList:state => state.user.userGroupList,
            isDepartmentAdmin: state => state.permission.isDepartmentAdmin,
            isSuperAdmin: state => state.permission.isSuperAdmin,
            hasDepartmentMenus:state => state.user.hasDepartmentMenus,
            departmentId: state => state.department.currentId,
            selectTypeGroupFirst: state => state.config.initSelectType == Const.SelectType.usergroup,
        }),
    },
    methods: {
        switchTab(name){
            this.filter.selectType = parseInt(name);
        },
        hasDepPermission(){
            if(this.filter.depId && this.filter.depId != 0){
                if(this.isSuperAdmin || this.isDepartmentAdmin){
                    return true;
                }else return !!this.hasPermission('selectliveRoomData');
            }else {
                return false;
            }
        }
    },
    mounted() {
       
    }
};
</script>


<style lang="less" scoped>
  .box {

    }
</style>